import { ProductCardProps } from "./Card";
import {
  Modal,
  ModalContent,
  ModalBody,
  Image,
  Tooltip,
} from "@heroui/react";
import SimpleSlider from "./swiper";

type Item = {
  title: string;
  photo: string;
  description: string;
};

type ModalFoodProps = {
  food: ProductCardProps & {
    listProducts: Array<Item>;
    health?: string;
  };
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
};

const MAX_LEN = 150;
const truncate = (t?: string, n = MAX_LEN) =>
  !t ? "" : t.length > n ? `${t.slice(0, n)}…` : t;

function SliderContent({
  items,
  fallbackImage,
}: {
  items: Item[];
  fallbackImage: string;
}) {
  return (
    <SimpleSlider time={5000} autoplay={false} className="h-[320px] grid place-items-center">
      {items.map((p, i) => {
        const long = (p.description ?? "").length > MAX_LEN;
        const shortText = truncate(p.description);

        const contentFull = (
          <h5 className="max-w-sm whitespace-pre-wrap">{p.description}</h5>
        );

        const Description = (
          <h6 className="mt-0 text-center whitespace-pre-wrap">{shortText}</h6>
        );

        return (
          <div
            key={`${p.title}-${i}`}
            className="flex flex-col justify-center items-center w-full h-full place-self-center px-4"
          >
            <Image
              className="object-cover w-fit"
              src={p.photo || fallbackImage}
              height={200}
              alt={p.title}
            />
            <h6 className="mt-0 text-center">{p.title}</h6>
            {long ? (
              <Tooltip content={contentFull} placement="top" showArrow className="max-w-sm">
                {Description}
              </Tooltip>
            ) : (
              Description
            )}
          </div>
        );
      })}
    </SimpleSlider>
  );
}

export default function ModalFood({
  food,
  isOpen,
  onOpenChange,
}: ModalFoodProps) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      classNames={{
        wrapper: "z-[10000]",
        base: "z-[10001]",
        backdrop:
          "z-[9999] bg-linear-to-t from-zinc-900 to-zinc-900/10 backdrop-opacity-20",
      }}
      size="5xl"
      isDismissable
      style={{ backgroundColor: food.bgColor }}
    >
      <ModalContent>
        <>
          {/* === Layout COMPLETO (md y superiores) === */}
          <ModalBody className="my-10 overflow-hidden hidden md:flex md:flex-row">
            {/* Columna izquierda */}
            <div className="flex flex-col w-full md:w-1/2 justify-between px-10 text-white">
              <h2>Nuestras recetas con...</h2>
              <h2 className="py-5">{food.title}</h2>
              <h4 className="flex text-justify pl-4">Beneficios</h4>
              <h6 className="flex-1 text-justify pl-4 font-extralight ">{food.health}</h6>
            </div>

            {/* Columna derecha */}
            <div className="flex flex-col w-full md:w-1/2 text-white">
              <SliderContent items={food.listProducts} fallbackImage={food.image} />
            </div>
          </ModalBody>

          {/* === Layout SIMPLE (pantallas pequeñas < md) === */}
          <ModalBody className="my-8 overflow-hidden flex flex-col gap-2 md:hidden text-white">
            <h5 className="">Nuestras recetas con...</h5>
            <h3 className="">{food.title}</h3>
            <SliderContent items={food.listProducts} fallbackImage={food.image} />
          </ModalBody>
        </>
      </ModalContent>
    </Modal>
  );
}
